import { render, staticRenderFns } from "./payment-method-list.vue?vue&type=template&id=0c2098f1&scoped=true"
import script from "./payment-method-list.vue?vue&type=script&lang=js"
export * from "./payment-method-list.vue?vue&type=script&lang=js"
import style0 from "./payment-method-list.vue?vue&type=style&index=0&id=0c2098f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2098f1",
  null
  
)

export default component.exports